const size = (factor) => 8 * factor;
/**
 * Spacer Size
 */
export var BoxItemSize;
(function (BoxItemSize) {
    BoxItemSize[BoxItemSize["NONE"] = 0] = "NONE";
    BoxItemSize[BoxItemSize["SMALL"] = size(2)] = "SMALL";
    BoxItemSize[BoxItemSize["MEDIUM"] = size(4)] = "MEDIUM";
    BoxItemSize[BoxItemSize["LARGE"] = size(8)] = "LARGE";
    BoxItemSize[BoxItemSize["HUGE"] = size(12)] = "HUGE";
})(BoxItemSize || (BoxItemSize = {}));
//# sourceMappingURL=BoxItemEnum.js.map